'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_AUTHORS_REQUEST: 'FETCH_AUTHORS_REQUEST',
    FETCH_AUTHORS_SUCCEEDED: 'FETCH_AUTHORS_SUCCEEDED',
    FETCH_AUTHORS_FAILED: 'FETCH_AUTHORS_FAILED'
};

function fetchAuthorsRequest() {
    return {
        type: actionTypes.FETCH_AUTHORS_REQUEST
    };
}

function fetchAuthorsSucceeded(authors) {
    return {
        type: actionTypes.FETCH_AUTHORS_SUCCEEDED,
        authors: authors
    };
}

function fetchAuthorsFailed() {
    return {
        type: actionTypes.FETCH_AUTHORS_FAILED
    };
}

var actionCreators = {
    fetchAuthorsRequest: fetchAuthorsRequest,
    fetchAuthorsSucceeded: fetchAuthorsSucceeded,
    fetchAuthorsFailed: fetchAuthorsFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvYWN0aW9ucy9hdXRob3JzLmpzIl0sIm5hbWVzIjpbImFjdGlvblR5cGVzIiwiRkVUQ0hfQVVUSE9SU19SRVFVRVNUIiwiRkVUQ0hfQVVUSE9SU19TVUNDRUVERUQiLCJGRVRDSF9BVVRIT1JTX0ZBSUxFRCIsImZldGNoQXV0aG9yc1JlcXVlc3QiLCJ0eXBlIiwiZmV0Y2hBdXRob3JzU3VjY2VlZGVkIiwiYXV0aG9ycyIsImZldGNoQXV0aG9yc0ZhaWxlZCIsImFjdGlvbkNyZWF0b3JzIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLElBQU1BLGNBQWM7QUFDaEJDLDJCQUF1Qix1QkFEUDtBQUVoQkMsNkJBQXlCLHlCQUZUO0FBR2hCQywwQkFBc0I7QUFITixDQUFwQjs7QUFNQSxTQUFTQyxtQkFBVCxHQUErQjtBQUMzQixXQUFPO0FBQ0hDLGNBQU1MLFlBQVlDO0FBRGYsS0FBUDtBQUdIOztBQUVELFNBQVNLLHFCQUFULENBQStCQyxPQUEvQixFQUF3QztBQUNwQyxXQUFPO0FBQ0hGLGNBQU1MLFlBQVlFLHVCQURmO0FBRUhLO0FBRkcsS0FBUDtBQUlIOztBQUVELFNBQVNDLGtCQUFULEdBQThCO0FBQzFCLFdBQU87QUFDSEgsY0FBTUwsWUFBWUc7QUFEZixLQUFQO0FBR0g7O0FBRUQsSUFBTU0saUJBQWlCO0FBQ25CTCw0Q0FEbUI7QUFFbkJFLGdEQUZtQjtBQUduQkU7QUFIbUIsQ0FBdkI7O1FBTVNSLFcsR0FBQUEsVztRQUFhUyxjLEdBQUFBLGMiLCJmaWxlIjoiYXV0aG9ycy5qcyIsInNvdXJjZVJvb3QiOiIvc3JjIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgYWN0aW9uVHlwZXMgPSB7XG4gICAgRkVUQ0hfQVVUSE9SU19SRVFVRVNUOiAnRkVUQ0hfQVVUSE9SU19SRVFVRVNUJyxcbiAgICBGRVRDSF9BVVRIT1JTX1NVQ0NFRURFRDogJ0ZFVENIX0FVVEhPUlNfU1VDQ0VFREVEJyxcbiAgICBGRVRDSF9BVVRIT1JTX0ZBSUxFRDogJ0ZFVENIX0FVVEhPUlNfRkFJTEVEJyxcbn07XG5cbmZ1bmN0aW9uIGZldGNoQXV0aG9yc1JlcXVlc3QoKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgICAgdHlwZTogYWN0aW9uVHlwZXMuRkVUQ0hfQVVUSE9SU19SRVFVRVNUXG4gICAgfTtcbn1cblxuZnVuY3Rpb24gZmV0Y2hBdXRob3JzU3VjY2VlZGVkKGF1dGhvcnMpIHtcbiAgICByZXR1cm4ge1xuICAgICAgICB0eXBlOiBhY3Rpb25UeXBlcy5GRVRDSF9BVVRIT1JTX1NVQ0NFRURFRCxcbiAgICAgICAgYXV0aG9yc1xuICAgIH07XG59XG5cbmZ1bmN0aW9uIGZldGNoQXV0aG9yc0ZhaWxlZCgpIHtcbiAgICByZXR1cm4ge1xuICAgICAgICB0eXBlOiBhY3Rpb25UeXBlcy5GRVRDSF9BVVRIT1JTX0ZBSUxFRFxuICAgIH07XG59XG5cbmNvbnN0IGFjdGlvbkNyZWF0b3JzID0ge1xuICAgIGZldGNoQXV0aG9yc1JlcXVlc3QsXG4gICAgZmV0Y2hBdXRob3JzU3VjY2VlZGVkLFxuICAgIGZldGNoQXV0aG9yc0ZhaWxlZCxcbn07XG5cbmV4cG9ydCB7IGFjdGlvblR5cGVzLCBhY3Rpb25DcmVhdG9ycyB9O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/authors.js
// module id = 478
// module chunks = 0